import { validateContent } from '../../validations/content';
import { validateImages } from '../../validations/images';
import { validate, setErrorsFromValidationResults } from '../../validations/validate';
import { showNotification } from '../../../../../../app/common/helpers/notifications';
export var validateStep = function (params) {
    var validationResults = validate(params, [validateContent, validateImages]);
    setErrorsFromValidationResults({ store: params.store, validationResults: validationResults });
    var hasAnyEmailError = validationResults.errors.some(function (error) {
        return error.field === 'emailBody' ||
            error.field === 'emailCoverImage' ||
            error.field === 'emailLogoImage' ||
            error.field === 'emailSubject' ||
            error.field === 'emailTitle';
    });
    if (hasAnyEmailError) {
        showNotification({
            title: 'Finish your email',
            message: 'Add the required content to continue.',
            level: 'error',
        });
    }
    var hasSmsError = validationResults.errors.some(function (error) { return error.field === 'smsBody'; });
    if (hasSmsError) {
        showNotification({
            title: 'SMS message missing',
            message: 'Write a clear message for your clients.',
            level: 'error',
        });
    }
    var hasPushError = validationResults.errors.some(function (error) { return error.field === 'pushBody'; });
    if (hasPushError) {
        showNotification({
            title: 'Push message missing',
            message: 'Write a short, catchy push notification message.',
            level: 'error',
        });
    }
    return validationResults.isValid;
};
